<div class="navblock">
  <button (click)="openCreateModal()" *ngIf="canAdd" class="btnadd">{{'Add object'|translate}}</button>
  <app-group-filter #groupFilter [groups]="groups" [canEditGroup]="canEditGroup.bind(this)"
    [canDeleteGroup]="canDeleteGroup.bind(this)" (onAddGroup)="openGroupAccessDialog()"
    (onEditGroup)="openGroupAccessDialog($event)" (onDeleteGroup)="deleteGroup($event)"
    (onSelectGroup)="selectGroup($event)"></app-group-filter>
  <app-objects-filter (onSearch)="onExtendedTermChange($event)"></app-objects-filter>
  <div class="company-filter">
    <p-multiselect [options]="companies" [ngModel]="extendedFilter.companyIds"
      (ngModelChange)="onCompanyFilterChange($event)" optionLabel="Name" optionValue="Id" [filter]="true"
      filterBy="Name" [showClear]="true" [appendTo]="'body'" styleClass="objects-company-multiselect"
      panelStyleClass="objects-company-multiselect-panel" [placeholder]="'All companies' | translate"></p-multiselect>
  </div>
</div>
<div class="tablewrap">
  <div class="table">
    <table fixedcols="[0, 1, 7]" id="exporttable">
      <tr>
        <th>
          <switch-all-checkbox [items]="filteredObjects" />
        </th>
        <th>&nbsp;</th>
        <th>{{'Name'|translate}}</th>
        <th>{{'Description'|translate}}</th>
        <th>{{'Device ID'|translate}}</th>
        <th>{{'Owner'|translate}}</th>
        <th>{{'Phone №'|translate}}</th>
        <th>{{'Model'|translate}}</th>
        <th>{{'Status'|translate}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let obj of filteredObjects | pagesfilter: pageInfoFilter; trackBy: trackByObjectId"
        [ngClass]="{'crossed': obj.Status == ObjectStatus.Deleted}">
        <td>
          <input type="checkbox" [(ngModel)]="obj.IsChecked" />
        </td>
        <td>
          <img src="{{obj.Icon.Url}}" />
        </td>
        <td>{{obj.Name}}</td>
        <td>{{obj.Comment}}</td>
        <td>{{obj.IMEI}}</td>
        <td>{{GetCompanyName(obj.CompanyId)}}</td>
        <td>{{obj.Phone}}{{obj.Phone1 ? ', ' + obj.Phone1 : ''}}</td>
        <td>{{obj.Model | translate}}</td>
        <td>{{ getStatusName(obj.Status) | translate}}</td>
        <td>
          <button class="btn_img btn_edit" [class.is-disabled]="!canEditObject(obj)"
            [attr.disabled]="!canEditObject(obj) ? '' : null" (click)="onEditObject(obj)"
            title="{{'Edit'|translate}}"></button>
          <button class="btn_img btn_dublicate" (click)="createDuplicate(obj)"
            title="{{'Duplicate'|translate}}"></button>
          <button class="btn_img btn_trush" [class.is-disabled]="!canDeleteObject(obj)"
            [attr.disabled]="!canDeleteObject(obj) ? '' : null" (click)="onDeleteObject(obj.Id, obj)"
            title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [viewMode]="'print excel pages'"
  (onPageChange)="onPageChange($event)" [items]="filteredObjects">
  <div export style="display:inline-block" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DATAINFO)">
    <div class="btn_img btn_graygray dropup btn_export-import dropclick">
      <ul>
        <li *ngIf="canImport" (click)="openImportObjectsDialog()">
          {{'Import'|translate}}
        </li>
        <li (click)="exportJsonFile()">
          {{'Export'|translate}}
        </li>

        <li (click)="openSetIconDialog()">{{'Set icons'|translate}}</li>
        <li [routerLink]="['/datainfo']">{{'Raw data'|translate}}</li>
        <li [routerLink]="['/diagnostics']">{{'Diagnostics'|translate}}</li>
      </ul>
    </div>
  </div>
</app-footer-component>

<template #mgmtDialog></template>
<template #groupMgmtDialog></template>
<template #objectsListDialog></template>

<app-object-group-access [objects]="objects" [filter]="extendedFilter"
  (groupsChanged)="onGroupsChanged()"></app-object-group-access>
